import { ReadAuditLog } from "@/types/auditLog";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

const formatValue = (value: unknown): string => {
  if (value === null || value === undefined) return "-";
  if (typeof value === "object") return JSON.stringify(value);
  return String(value);
};

interface AuditLogDiffProps {
  auditLog: ReadAuditLog;
}

export const AuditLogDiff = ({ auditLog }: AuditLogDiffProps) => {
  const { t } = useTranslation();

  const allFields = useMemo(() => {
    const oldKeys = Object.keys(auditLog.old_data || {});
    const newKeys = Object.keys(auditLog.new_data || {});
    return [...new Set([...oldKeys, ...newKeys])];
  }, [auditLog]);

  return (
    <div className="rounded-lg p-4 mb-4 bg-muted/50 border border-border">
      <div className="grid grid-cols-[1fr_2fr_2fr] gap-4 mb-2">
        <h3 className="text-sm font-semibold text-foreground">
          {t("auditLogs.diff.field")}
        </h3>
        <h3 className="text-sm font-semibold text-foreground">
          {t("auditLogs.diff.oldValue")}
        </h3>
        <h3 className="text-sm font-semibold text-foreground">
          {t("auditLogs.diff.newValue")}
        </h3>
      </div>
      <div className="space-y-1">
        {allFields.map((field) => {
          const oldValue = auditLog.old_data?.[field];
          const newValue = auditLog.new_data?.[field];
          const hasChanged =
            JSON.stringify(oldValue) !== JSON.stringify(newValue);

          return (
            <div
              key={field}
              className={`grid grid-cols-[1fr_2fr_2fr] gap-4 py-2 px-2 rounded ${
                hasChanged ? "bg-background/50" : ""
              }`}
            >
              <span className="text-sm font-medium break-words">{field}</span>
              <span className="font-mono text-sm break-all">
                {formatValue(oldValue)}
              </span>
              <span className="font-mono text-sm break-all">
                {formatValue(newValue)}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};
